import styled from 'styled-components';
import Modal from 'react-modal';
import Button from '../Button';
import { IoClose } from 'react-icons/io5';

export const ModalWrapper = styled(Modal)`
  width: 350px;
  height: 400px;
  background-color: white;
  padding-inline: 20px;
  padding-block: 10px;
  display: flex;
  flex-direction: column;
`;

export const CloseButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
`;
export const CloseButton = styled(Button).attrs({
  wrapperStyle: {
    width: '28px',
    height: '28px',
    backgroundColor: 'transparent',
  },
  type: 'rounded',
  icon: IoClose,
  iconProps: {
    color: 'Silver',
    size: '28px',
  },
})``;

export const ModalTitle = styled.h3`
  font-weight: 500;
  padding-inline: 10px;
`;

export const ModalDesctiption = styled.p`
  line-height: 30px;
  padding-inline: 10px;
  font-size: 0.875rem;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  height: 100%;
`;

export const ControlButton = styled(Button).attrs({
  wrapperStyle: {
    minWidth: '35%',
    maxWidth: '45%',
    height: 'auto',
    width: 'auto',
    padding: '10px',
  },
})``;
